import { render, staticRenderFns } from "./AnchorableContentModule.vue?vue&type=template&id=d864e77c&"
import script from "./AnchorableContentModule.ts?vue&type=script&lang=ts&"
export * from "./AnchorableContentModule.ts?vue&type=script&lang=ts&"
import style0 from "./AnchorableContentModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports